import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = () => (
  <div className="loader-container">
    <span className="loader"></span>
  </div>
);

export default LoadingSpinner;
